import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Modal, Badge, Spinner, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import PageNotFound from './pages/PageNotFound';
import EquipmentMgmt from './pages/EquipmentMgmt';
import Layout from './components/Layout/Layout';
import {
  fetchApplicationData,
  getAppData,
  getAppDataLoaded,
} from './app/environment/environmentSlice';
import { changeRoute, fetchCurrentRoute } from './components/Layout/LayoutSlice';
import { logout, navigateTo } from './helpers/utilities';
import './App.css';
import InterconnectHome from './pages/Interconnect';
import  PreApp from './pages/PreApplication';
import ProjectView from './pages/ProjectView';
import Login from './pages/Login';


function App() {
  const [isUnauth, setUnAuth] = useState(false);
  const [invalidSession, setInvalidSession] = useState(false);

  const [remainingTime, setRemainingTime] = useState(5000);
  const appData = useSelector(getAppData);
  const show = useSelector(getAppDataLoaded);
  const [showApp, setShowApp] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const currentRoute = useSelector(fetchCurrentRoute);


  useEffect(() => {
    dispatch(fetchApplicationData());
    const unauthorised = JSON.parse(Cookies.get('aep-unauthorised') || false);
    if (unauthorised) {
      setUnAuth(unauthorised);
    }
  }, []);
  useEffect(() => {
    setShowApp(show);
  }, [show]);

  useEffect(() => {
    if (showApp && !isUnauth) {
      const hasToken = Cookies.get('isLoggedIn');
      if ((typeof hasToken === 'undefined' || hasToken === '') && appData) {
        setInvalidSession(true);
      }
    }
  }, [showApp, appData, isUnauth]);

  useEffect(() => {
    const { pathname } = location;
    let currentRoute = '';
    if (
      pathname === '/' ||
      pathname === '/appHome' ||
      pathname.includes('/appHome')
    ) {
      currentRoute = '/appHome';
    } else {
      currentRoute = pathname;
    }
    dispatch(changeRoute(currentRoute));
  }, [location, dispatch]);

  const onInvalidSessionModalExit = () => {
    //TODO: comment below for dev purpose to skip login
    logout(appData);
  };

  const onUnAuthModalExit = () => {
    Cookies.remove('aep-unauthorised');
    appData.REACT_APP_HOME_URL && navigateTo(appData.REACT_APP_HOME_URL);
  };

  const onUnAuthModalShow = () => {
    let tmpRemainingTime = remainingTime;
    setInterval(() => {
      tmpRemainingTime -= 1000;
      setRemainingTime(tmpRemainingTime);
    }, 1000);
    setTimeout(() => {
      if (invalidSession) {
        setInvalidSession(false);
      } else {
        setUnAuth(false);
      }
    }, remainingTime);
  };

  return (
    <div className="App">
      {showApp ? (
        <>
          <Routes>
            <Route path="/appLogin" exact element={<Login />} />
            <Route path="/appHome" exact element={<InterconnectHome />} />
            <Route path="appHome/preapp" exact element={<PreApp />} />
            <Route path="/eqpMgmt" element={<EquipmentMgmt />} />
            <Route path="/projectHome" element={<ProjectView />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </>
      ) : (
        <Layout>
          <Row className="justify-content-center m-5">
            <Col />
            <Spinner
              className="app-spinner"
              animation="grow"
              variant="info"
              size="lg"
            />
          </Row>
        </Layout>
      )}
      <Modal
        centered
        size="lg"
        onShow={() => {
          onUnAuthModalShow();
        }}
        onExited={() => {
          onInvalidSessionModalExit();
        }}
        show={invalidSession && !currentRoute.includes('/appLogin')}
        onHide={() => {
          setInvalidSession(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Session Invalid</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="text-center">Please login again</h5>
          <h6 className="text-center">
            You'll be redirect to login page in:&nbsp;
            <Badge bg="light" text="danger">
              {remainingTime / 1000} second(s)
            </Badge>
          </h6>
        </Modal.Body>
      </Modal>
      <Modal
        centered
        size="lg"
        onShow={() => {
          onUnAuthModalShow();
        }}
        onExited={() => {
          onUnAuthModalExit();
        }}
        show={isUnauth && !currentRoute.includes('/appLogin')}
        onHide={() => {
          setUnAuth(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Authorization Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="text-center">
            You are unauthorized to access this application
          </h5>
          <h6 className="text-center">
            You will be redirected to login page in &nbsp;
            <Badge bg="light" text="danger">
              {remainingTime / 1000} second(s)
            </Badge>
          </h6>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default App;
